import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { IRadioInfo } from 'src/types/FormControlRadioGroupProps';
import { ISiteStudyPersonalResponse } from 'src/types/SiteStudyPersonal';
import { KeyValue, formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const getDefaultOptions = (): KeyValue[] => [
  { key: 'yes', value: 'Y' },
  { key: 'no', value: 'N' }
];

export const getOptions = (...args: KeyValue[]): IRadioInfo[] => {
  return args.map((arg): IRadioInfo => {
    return { value: arg.value, labelkey: arg.key };
  });
};

export const getResponseWithDefaultOptions = (data: ISiteStudyPersonalResponse): ISiteStudyPersonalResponse => {
  data.study_id_enabled = data.site.identified_for_study.trim().toLowerCase() === 'y';
  data.site.study_id = data.study.study_id;
  data.personnel.forEach(personel => (personel.study_id = data.study.study_id));
  data.options = getOptions(...getDefaultOptions());
  return data;
};

export const siteStudyPersonnelApi = createApi({
  baseQuery,
  reducerPath: 'siteStudyPersonnelApi',
  endpoints: builder => ({
    getSiteStudyPersonnel: builder.query<
      ISiteStudyPersonalResponse,
      { site_id: any; study_id: any; country: any; application: any }
    >({
      query: ({ site_id, study_id, country, application }) => ({
        url: formatString(
          endPoints.SiteStudyPersonnel.siteStudyPersonnelSelect,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.country, value: country },
          { key: urlKeys.application, value: application }
        )
      }),
      transformResponse: (response: ISiteStudyPersonalResponse) => {
        return getResponseWithDefaultOptions(response);
      }
    }),
    getSiteStudyPersonnelCopy: builder.query<
      ISiteStudyPersonalResponse,
      { site_id: any; study_id: any; country: any; application: any }
    >({
      query: ({ site_id, study_id, country, application }) => ({
        url: formatString(
          endPoints.SiteStudyPersonnel.siteStudyPersonnelSelect,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.country, value: country },
          { key: urlKeys.application, value: application }
        )
      })
    })
  })
});

export const { useGetSiteStudyPersonnelQuery, useLazyGetSiteStudyPersonnelCopyQuery } = siteStudyPersonnelApi;
